// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TuLb","left":"styles_left__-XOhP","desktopActions":"styles_desktopActions__1Pin3","title":"styles_title__1URQv"};